import * as Yup from "yup";
import { enumToSelectItemsWithValuesAsKeys } from "web_modules/shared/FormHelpers/carbon-helpers";

enum VAPurposeOfLoan {
  VAPurposeOfLoanPurchaseExistingHomePreviouslyOccupied = "PurchaseExistingHomePreviouslyOccupied",
  VAPurposeOfLoanPurchaseExistingHomeNotPreviouslyOccupied = "PurchaseExistingHomeNotPreviouslyOccupied",
  VAPurposeOfLoanFinanceImprovementsToExistingProperty = "FinanceImprovementsToExistingProperty",
  VAPurposeOfLoanRefinance = "Refinance",
  VAPurposeOfLoanPurchaseNewCondoUnit = "PurchaseNewCondoUnit",
  VAPurposeOfLoanPurchaseExistingCondoUnit = "PurchaseExistingCondoUnit",
  VAPurposeOfLoanConstructHome = "ConstructHome",
  VAPurposeOfLoanFinanceCoopPurchase = "FinanceCoopPurchase",
  VAPurposeOfLoanPurchasePermanentlySitedManufacturedHome = "PurchasePermanentlySitedManufacturedHome",
  VAPurposeOfLoanPurchasePermanentlySitedManufacturedHomeAndLot = "PurchasePermanentlySitedManufacturedHomeAndLot",
  VAPurposeOfLoanRefiPermanentlySitedManufacturedHomeToBuyLot = "RefiPermanentlySitedManufacturedHomeToBuyLot",
  VAPurposeOfLoanRefiPermanentlySitedManufacturedHomeLotLoan = "RefiPermanentlySitedManufacturedHomeLotLoan",
}

enum VAOccupancy {
  VAOccupancyBorrowerOccupy = "BorrowerOccupy",
  VAOccupancyOccupyForSpouseOnActiveMilitaryDuty = "OccupyForSpouseOnActiveMilitaryDuty",
  VAOccupancyPreviouslyBorrowerOccupied = "PreviouslyBorrowerOccupied",
  VAOccupancyPreviouslyOccupiedForSpouseOnActiveMilitaryDuty = "PreviouslyOccupiedForSpouseOnActiveMilitaryDuty",
  VAOccupancyDependentChildOccupyForActiveMilitaryDuty = "DependentChildOccupyForActiveMilitaryDuty",
  VAOccupancyPreviouslyDependentChildOccupiedForActiveMilitaryDuty = "PreviouslyDependentChildOccupiedForActiveMilitaryDuty",
}

export enum VAVestingType {
  VAVestingTypeVeteran = "Veteran",
  VAVestingTypeVeteranAndSpouse = "VeteranAndSpouse",
  VAVestingTypeOther = "Other",
}

export const VAPurposeOfLoanOptions = enumToSelectItemsWithValuesAsKeys(VAPurposeOfLoan);
export const VAOccupancyOptions = enumToSelectItemsWithValuesAsKeys(VAOccupancy);
export const VAVestingTypeOptions = enumToSelectItemsWithValuesAsKeys(VAVestingType);

export const validationSchema = Yup.object().shape({
  vesting_type_other_description: Yup.string().when("vesting_type", {
    is: VAVestingType.VAVestingTypeOther,
    then: Yup.string().required("Please specify the vesting type"),
    otherwise: Yup.string().nullable(),
  }),
});

export const initialValues = {
  agency_case_number: "",
  purpose_of_loan: "",
  previous_va_home_loan: null,
  occupancy: "",
  was_aware_of_lower_valuation: null,
  vesting_type: "",
  vesting_type_other_description: "",
  funding_fee_financing: null,

  is_va_loan_application_borrower_value: false,
};
